import request from './request'

export function generatePrompt(data) {
    return request({
        url: '/generate_prompt',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function uploadImg(dir, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('dir', dir);

    console.log('上传的文件:', file);
    console.log('上传的表单数据:', formData.get('file'));

    return request({
        url: '/api/upload/image',
        method: 'post',
        data: formData
    })
}

export function wsUploadFile(params, formData) {
  Object.entries(params).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return request({
    url: '/api/upload/ws/uploadToObs',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function lxUploadFile(formData) { 
    return request({
        url: '/api/upload/imageObs',
        method: 'post', 
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function uploadResume(options) {
  const { file, url, onProgress, onSuccess, onError, encodeFileName = false } = options
  
  if (!url) {
    const error = new Error('上传 URL 不能为空')
    if (onError) {
      onError(error)
    }
    return Promise.reject(error)
  }
  
  // 创建 FormData
  const formData = new FormData()
  
  let fileToUpload = file
  if (encodeFileName && file.name) {
    try {
      const encodedFileName = encodeURIComponent(file.name)
      // 创建新的 File 对象，使用编码后的文件名
      fileToUpload = new File([file], encodedFileName, {
        type: file.type,
        lastModified: file.lastModified
      })
    } catch (error) {
      console.warn('文件名编码失败，使用原始文件名:', error)
    }
  }
  
  formData.append('file', fileToUpload)
  
  // 使用 request 上传，支持进度回调
  return request({
    url: url,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      if (progressEvent.total && onProgress) {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        onProgress({ percent })
      }
    }
  })
    .then((response) => {
      if (onSuccess) {
        onSuccess(response.data || response)
      }
      return response
    })
    .catch((error) => {
      console.error('上传失败:', error)
      if (onError) {
        onError(error)
      }
      throw error
    })
}

export function generate_qrcode() {
  return request({
    url: '/api/upload/generate_qrcode',
    method: 'get',
  })
}

/* /api/interview/screenshot/save post 保存面试截图（入参）面试id(interviewId),截图图片地址(imageUrl),截图时间(秒)(screenshotTime)

/api/interview/screenshot/list/{interviewId} Get 获取面试截图列表  */
export function saveInterviewScreenshot(data) {
  return request({
    url: '/api/interview/screenshot/save',
    method: 'post',
    data,
  })
}

export function getInterviewScreenshotList(interviewId) {
  return request({
    url: '/api/interview/screenshot/list/' + interviewId,
    method: 'get',
  })
}

// 通过URL解析简历
export function parseResumeByUrl(url) {
  return request({
    url: '/api/resume/parseByUrl',
    method: 'get',
    params: {
      url: url
    }
  })
}









// WebSocket 连接管理类
class WebSocketManager {
    constructor() {
        this.ws = null;
        this.isConnected = false;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectInterval = 3000; // 3秒
        this.heartbeatInterval = null;
        this.messageCallbacks = new Map();
    }

    // 建立WebSocket连接
    connect(userId) {
        return new Promise((resolve, reject) => {
            if (this.isConnected) {
                resolve(this.ws);
                return;
            }

            try {

                const isDev = process.env.NODE_ENV === 'development';

                let wsUrl = '';
                if (isDev) {
                  // 开发环境使用本地WebSocket服务器
                  wsUrl = `ws://localhost:8080/wxUpload/${userId}`;
                } else {
                  // 生产环境使用远程WebSocket服务器
                  const host = window.location.host;
                  wsUrl = `wss://${host}/wxUpload/${userId}`;
                 
                }
                this.ws = new WebSocket(wsUrl);

                this.ws.onopen = () => {
                    console.log('WebSocket连接已建立');
                    this.isConnected = true;
                    this.reconnectAttempts = 0;
                    this.startHeartbeat();
                    resolve(this.ws);
                };

                this.ws.onmessage = (event) => {
                    try {
                        console.log('WebSocket原始消息:', event.data);
                        const data = JSON.parse(event.data);
                        
                        // 检查是否是标准格式消息
                        if (data.type && data.data !== undefined) {
                            this.handleMessage(data);
                        } else {
                            // 如果不是标准格式，直接作为数据传递
                            console.log('收到非标准格式消息，直接处理:', data);
                            // 触发默认的消息处理
                            if (this.messageCallbacks.has('file_upload_complete')) {
                                this.messageCallbacks.get('file_upload_complete').forEach(callback => {
                                    callback(data);
                                });
                            }
                        }
                    } catch (error) {
                        console.error('解析WebSocket消息失败:', error);
                    }
                };

                this.ws.onclose = (event) => {
                    console.log('WebSocket连接已关闭:', event.code, event.reason);
                    this.isConnected = false;
                    this.stopHeartbeat();
                    
                    // 如果不是主动关闭，尝试重连
                    if (event.code !== 1000 && this.reconnectAttempts < this.maxReconnectAttempts) {
                        this.reconnect(userId);
                    }
                };

                this.ws.onerror = (error) => {
                    console.error('WebSocket连接错误:', error);
                    reject(error);
                };

            } catch (error) {
                console.error('创建WebSocket连接失败:', error);
                reject(error);
            }
        });
    }

    // 重连机制
    reconnect(userId) {
        this.reconnectAttempts++;
        console.log(`尝试重连 (${this.reconnectAttempts}/${this.maxReconnectAttempts})`);
        
        setTimeout(() => {
            this.connect(userId).catch(error => {
                console.error('重连失败:', error);
            });
        }, this.reconnectInterval);
    }

    // 发送消息
    sendMessage(type, data = {}) {
        if (!this.isConnected || !this.ws) {
            throw new Error('WebSocket未连接');
        }

        const message = {
            type,
            data,
            timestamp: Date.now()
        };

        this.ws.send(JSON.stringify(message));
    }

    // 处理接收到的消息
    handleMessage(data) {
        const { type, data: messageData } = data;
        
        console.log('WebSocket收到消息:', { type, messageData });
        
        // 触发对应类型的回调
        if (this.messageCallbacks.has(type)) {
            this.messageCallbacks.get(type).forEach(callback => {
                callback(messageData);
            });
        }
    }

    // 注册消息监听器
    onMessage(type, callback) {
        if (!this.messageCallbacks.has(type)) {
            this.messageCallbacks.set(type, []);
        }
        this.messageCallbacks.get(type).push(callback);
    }

    // 移除消息监听器
    offMessage(type, callback) {
        if (this.messageCallbacks.has(type)) {
            const callbacks = this.messageCallbacks.get(type);
            const index = callbacks.indexOf(callback);
            if (index > -1) {
                callbacks.splice(index, 1);
            }
        }
    }

    // 心跳机制
    startHeartbeat() {
        this.heartbeatInterval = setInterval(() => {
            if (this.isConnected) {
                this.sendMessage('heartbeat', {});
            }
        }, 30000); // 30秒发送一次心跳
    }

    stopHeartbeat() {
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        }
    }

    // 关闭连接
    disconnect() {
        if (this.ws) {
            this.ws.close(1000, '主动关闭连接');
            this.isConnected = false;
            this.stopHeartbeat();
        }
    }

    // 获取连接状态
    getConnectionStatus() {
        return {
            isConnected: this.isConnected,
            reconnectAttempts: this.reconnectAttempts
        };
    }
}

// 创建全局WebSocket管理器实例
const wsManager = new WebSocketManager();

// 导出WebSocket相关函数
export function createWebSocketConnection(userId) {
    return wsManager.connect(userId);
}

export function sendWebSocketMessage(type, data) {
    return wsManager.sendMessage(type, data);
}

export function onWebSocketMessage(type, callback) {
    wsManager.onMessage(type, callback);
}

export function offWebSocketMessage(type, callback) {
    wsManager.offMessage(type, callback);
}

export function closeWebSocketConnection() {
    wsManager.disconnect();
}

export function getWebSocketStatus() {
    return wsManager.getConnectionStatus();
}

export { wsManager };
